// Curated imagery for the storefront. Dark, market/nature themed.
export const IMG = {
  heroBackdrop:
    "https://images.pexels.com/photos/38375326/pexels-photo-38375326.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  matrix:
    "https://images.pexels.com/photos/1089438/pexels-photo-1089438.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  charts:
    "https://images.pexels.com/photos/6770610/pexels-photo-6770610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  forest:
    "https://images.pexels.com/photos/14537809/pexels-photo-14537809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  authPanel:
    "https://images.pexels.com/photos/14537809/pexels-photo-14537809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=800",
};
